import { createFileRoute } from '@tanstack/react-router';

import { resetPasswordSearchSchema } from '@/_pages/auth/shared/schemas';
import Loading from '@/_pages/reset-password/loading';

export const Route = createFileRoute('/_public/reset-password/')({
  validateSearch: resetPasswordSearchSchema,
  pendingComponent: Loading,
});
